import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" tekrevol_dark_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Development">
                            <h2>Build Secure, Fast And Robust Applications Through Our Node.Js Development Company</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>We love how Node.js helps us build intuitive web apps that seamlessly transfer real-time hyper-scale data. It is a robust backend environment and syncs with our dynamic development teams and dedicated development environments.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;